export default __webpack_public_path__ + "static/media/phone-screenshot.b67cd839.png";